export default __webpack_public_path__ + "static/media/LAS0090.34I107093_-17467_0.a4180c51.jpg";